import styled from 'styled-components';

import { baseSelectItem, textSizes } from 'utils/style';
import VenueSuggestionItem from 'components/AddressModal/components/VenueSuggestionItem/container';

export default styled(VenueSuggestionItem)`
  ${baseSelectItem};
  height: 100%;
  padding: 6px 16px;

  .address {
    color: var(--grey900);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .subaddress {
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${textSizes('M')};
    color: var(--grey700);
  }
`;
